// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/night-vision.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/night-vision/night-vision.js';
import g1 from '../lessons/aeronautics/night-vision/off-center-night-scanning.js';

mount([g0, g1]);
